'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis;



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/path.js
// module id = 1411
// module chunks = 0